module.exports = __webpack_public_path__ + "static/media/staking.ca8934d2.png";